import { useEffect } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

const Login = ({ location, router }) => {
  const { auth } = router.routes[0]

  useEffect(() => {
    try {
      if (location.hash === '') {
        auth.login()
      }
    } catch (error) {
      // Handle login errors appropriately
      console.error('Login failed:', error)
    }
  }, [location.hash, auth])

  return null
}

Login.propTypes = {
  location: PropTypes.shape({
    hash: PropTypes.string
  }).isRequired,
  router: PropTypes.shape({
    routes: PropTypes.arrayOf(
      PropTypes.shape({
        auth: PropTypes.shape({
          login: PropTypes.func
        })
      })
    )
  }).isRequired
}

const mapStateToProps = state => ({
  location: state.routing.locationBeforeTransitions
})

export default connect(mapStateToProps, null)(Login)